<div class="content-wrapper">
    <div class="page-header">
        <h3 class="page-title" style="cursor: context-menu;">
            <span class="page-title-icon bg-gradient-success text-white mr-2">
                <i class="mdi mdi-account-multiple menu-icon"></i>
            </span> ประมาณการรายรับ

        </h3>
        <nav aria-label="breadcrumb">
            <button class="btn btn-warning btn-fw mr-1" data-toggle="modal" data-target="#updateURL_ht">อัพเดต URL
                ไฟล์</button>
            <button class="btn btn-inverse-success btn-fw" (click)="goToEdit()">แก้ไข</button>
        </nav>
    </div>

    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card" style="border-radius: 15px; height: 100vh;">
                <div id="maximizableTable" style="height: 100vh;">
                    <img src="https://cdn2.iconfinder.com/data/icons/mixed-vol-7/74/Untitled-1-11-08-07-17-512.png"
                        (click)="maximizeorMinimize('maximizableTable','maximizableBtn')" width="15px" height="15px"
                        id="maximizableBtn"
                        style="float: right; margin-top: 5px; margin-right: 5px; margin-bottom: 10px;" title="Maximize">
                    <iframe width="100%" height="100%" style="border:10px solid white; border-radius: 15px"
                        frameborder="0" scrolling="no" [src]="urlSafe"></iframe>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="updateURL_ht" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel-2">อัพเดต URL ไฟล์</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form class="forms-sample" [formGroup]="iframe_form" *ngIf="iframe_form">
                        <!-- <div class="form-group">
                            <label>ปี พ.ศ. ข้อมูล <span class="text-danger" *ngIf="!iframe_form.value.year">
                                    *</span></label>
                            <input class="form-control" type="number" formControlName="year" autocomplete="off">
                        </div> -->
                        <div class="form-group">
                            <label>URL แสดงไฟล์ <span class="text-danger" *ngIf="!iframe_form.value.iframe">
                                    *</span></label>
                            <textarea class="form-control" rows="3" formControlName="iframe"
                                autocomplete="off"></textarea>
                        </div>
                        <div class="form-group">
                            <label>URL แก้ไขไฟล์ <span class="text-danger" *ngIf="!iframe_form.value.edit">
                                    *</span></label>
                            <textarea class="form-control" rows="3" formControlName="edit"
                                autocomplete="off"></textarea>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" (click)="addIframe()"
                        [disabled]="!iframe_form.valid">บันทึก</button>
                    <button type="button" class="btn btn-light" data-dismiss="modal">ยกเลิก</button>
                </div>
            </div>
        </div>
    </div>
</div>